import { playerConnectionState, macroRunningState } from '../stores/playerStores';
import { initInviteAnalyticsListeners } from '../peerTelemetry/playerConnectionTelemetry';
import { joinInvitation, resolveJoinLink, startJoin } from '../modules/player';
import { closePeer } from '../modules/peer';
import { getPlatformFromPath } from '../../utility/utility';
import { joinState } from '../stores/globalStores';
import { invitationState } from '../stores/lobbyStores';
import { resetGamepadSelectionForNewSession } from '../../utility/gamepadSelection';

let isListening = false;

export const initializeConnectionEvents = () => {
  if (isListening) return;
  isListening = true;
  joinState.reset();
  // knockState.reset(true);
  invitationState.reset(true);
  playerConnectionState.reset();
  resetGamepadSelectionForNewSession(); // Reset gamepad selection when initializing new connection
  joinState.addListener(async (state) => {
    const status = state.state;
    if (status === 'idle') {
      console.log('Join state is idle');
      joinState.reset();
      // knockState.reset();
      invitationState.reset();
      playerConnectionState.reset();
      macroRunningState.reset(); // Clear the debug macro-running dot on session teardown
      closePeer('player:close:join_state_idle');
      // join id is /j/:joinid
      const joinIdFromParams = window.location.pathname.split('/').pop() || '';
      // get platform from params
      const platformFromParams = getPlatformFromPath(window.location.pathname);
      startJoin(platformFromParams, joinIdFromParams);
    } else if (status === 'resolvingAlias') {
      console.log('Resolving alias');
      resolveJoinLink();
    } else if (status === 'chooseDeck') {
      console.log('Choose deck');
    } else if (status === 'chooseInvite') {
      console.log('Choose invite');
      console.log('Invites', invitationState.currentState);
      if (Object.keys(invitationState.currentState.invites).length === 1) {
        const invite = Object.values(invitationState.currentState.invites)[0];
        if (invite) {
          invitationState.updateState({
            ...invitationState.currentState,
            selectedInvite: invite,
          });
        }
      }
    } else if (status === 'inQueue') {
      console.log('In queue');
      console.log('Invitation state', invitationState.currentState);
      if (invitationState.currentState.selectedInvite) {
        joinInvitation(invitationState.currentState.selectedInvite);
      }
      // console.log('Knock state', knockState.currentState);
      // if (knockState.currentState.status === 'idle') {
      //   if (invitationState.currentState.selectedInvite) {
      //     getNewKnock();
      //   }
      // }
    } else if (status === 'connecting') {
      console.log('Connecting');
      // if (invitationState.currentState.selectedInvite) {
      //   if (invitationState.currentState.selectedInvite.instantConnect) {
      //     // Is instantly connecting
      //     getInstantExchange();
      //   }
      // }
    } else if (status === 'hostConnected') {
      window.history.pushState({ stage: 'hostConnected' }, '');
      console.log('Host connected');
    } else if (status === 'hostDisconnected') {
      console.log('Host disconnected');
      if (document.fullscreenElement) document?.exitFullscreen();
      resetGamepadSelectionForNewSession(); // Reset gamepad selection on session end
      macroRunningState.reset(); // A macro can't be running once the host is gone; clear the debug dot
      closePeer('player:close:join_state_host_disconnected');
    } else if (status === 'playerDisconnected') {
      console.log('Player disconnected');
      if (document.fullscreenElement) document?.exitFullscreen();
      resetGamepadSelectionForNewSession(); // Reset gamepad selection on session end
      macroRunningState.reset(); // Clear the debug macro-running dot on session end
      closePeer(playerConnectionState.currentState.kickReason ?? 'player:close:join_state_player_disconnected');
    }
  });

  initInviteAnalyticsListeners();

  playerConnectionState.addListener((state, previousState) => {
    if (state.status === 'connected') {
      joinState.updateState({
        ...joinState.currentState,
        state: 'hostConnected',
      });

      // NOTE: "Player Joined Broadcast" analytics is now handled by QuickstartCoordinator
      // to avoid duplicates. This was previously sent here but caused duplicate events.
      // The coordinator sends this via BroadcastConnectionManager.sendBroadcastJoinSucceeded()
    } else if (state.status === 'connecting') {
      console.log('Host connecting');
    } else if (state.status === 'idle') {
      console.log('Host idle');
    } else if (state.status === 'disconnected' || state.status === 'failed' || state.status === 'refused') {
      console.error('Host connection failed', state.status, joinState.currentState.state);
      if (state.status === 'refused' || state.status === 'failed') {
        joinState.updateState({
          ...joinState.currentState,
          state: 'hostDisconnected',
        });
      }
      if (state.status === 'disconnected' && joinState.currentState.state === 'connecting') {
        joinState.updateState({
          ...joinState.currentState,
          state: 'hostDisconnected',
        });
      }
      if (state.status === 'disconnected' && joinState.currentState.state === 'hostConnected') {
        joinState.updateState({
          ...joinState.currentState,
          state: 'playerDisconnected',
        });
      }

      // NOTE: "Player Left Broadcast" analytics is now handled by QuickstartCoordinator
      // to match the pattern of "Player Joined Broadcast" and centralize quickstart analytics.
      // The coordinator sends this via disconnectPeer() when intentionally disconnecting.
    }
  });
};

export const cleanupConnectionEvents = () => {
  isListening = false;
  joinState.reset(true);
  invitationState.reset(true);
  playerConnectionState.reset();
  macroRunningState.reset(); // Clear the debug macro-running dot on cleanup
  closePeer('player:close:cleanup_connection_events');
};
